 {
    "common": {
    "thisWeek": "Esta semana",
    "lastWeek": "Semana passada",
    "lastNumberOfDays": "Últimos {numberOfDays} dias",
    "thisMonth": "Este mês"
    },
    "subAccounts": "Subcontas",
    "submitFeedback": "Enviar feedback",
    "createSubAccount": "Criar subconta",
    "viewScheduleReports": "Ver relatórios agendados",
    "searchSubAccount": "Pesquisar por subconta",
    "columns": "Colunas",
    "sortBy": "Ordenar por",
    "selectColumns": "Selecionar colunas",
    "maxColumns": "Máximo de 8 colunas num Data",
    "applyColumns": "Aplique colunas",
    "activeUsers": "Utilizadores ativos",
    "appointments": "Compromissos",
    "contacts": "Contactos",
    "emails": "Gmail",
    "textMessages": "Mensagens do corpo",
    "calls": "Chamadas",
    "submissions": "Envios",
    "reviews": "Avaliações",
    "sitesCreated": "Sites criados",
    "name": "Nome",
    "formSubmissions": "Envios de formulários",
    "surveySubmissions": "Envios de inquéritos",
    "facebookFormSubmissions": "Envios de formulários do Facebook",
    "funnels": "Funis",
    "websites": "Sítios Web",
    "forms": "Formulários",
    "surveys": "Inquéritos",
    "highestFirst": "Máximo primeiro",
    "lowestFirst": "O mais baixo primeiro",
    "orderBy": "Ordenar Via",
    "noMoreLocations": "Não mais endereço encontrado",
    "preparingReport": "Estamos a preparar o seu relatório…",
    "preparingReportDesc": "Não feche nem recarregue esta janela enquanto a exportação estiver em curso.",
    "outOf": "De",
    "subAccountsExported": "Subcontas exportadas",
    "close": "Fechar",
    "scheduledForDeletion": "Agendado para eliminação",
    "readyToSell": "Pronto a vender",
    "closedWon": "Fechada (ganha)",
    "wpSaleSuccessful": "A venda do WordPress foi bem-sucedido",
    "wpNotSold": "WordPress ainda não vendido",
    "yxtSaleSuccessful": "A venda do Yext foi bem-sucedido",
    "yxtNotSold": "Yext ainda não vendido",
    "saasSubInactive": "A assinatura SaaS é inativa",
    "saasSubTrialing": "SaaS Assinatura está a avaliar",
    "saasSubActive": "SaaS Assinatura é Dinâmico",
    "emailRebillingActive": "E-mail Faturação recorrente é Dinâmico",
    "emailRebillingInactive": "E-mail A Faturação recorrente é Inativo",
    "twilioRebillingActive": "Twilio Faturação recorrente é Dinâmico",
    "twilioRebillingInactive": "Twilio Faturação recorrente é Inativo",
    "wpRebillingActive": "A faturação recorrente do WhatsApp está ativa",
    "wpRebillingInactive": "A faturação recorrente do WhatsApp está inativa",
    "saasModeActivated": "O modo SaaS é Ativado",
    "paymentPending": "O pagamento está pendente",
    "saasModeNotActivated": "O modo SaaS não é Ativado",
    "managedByLCPhone": "Gerir Via LC Telefone",
    "migrationToLCPhone": "Em migração para o Telefone LC",
    "notManagedByLCPhone": "Não Gerir Via LC Telefone",
    "managedByLCEmail": "Gerir Via LeadConnector Email System",
    "notMangedByLCEmail": "Não Gerir Via LeadConnector Email System",
    "remainingWalletBalance": "Saldo restante da carteira desta localização SaaS",
    "reports": "Relatórios",
    "switchToSubAccount": "Mudar para subconta",
    "manageClient": "Gerir cliente",
    "subAccountDeletedIfChangedMind": "Esta subconta será eliminada em {time}, se tiver mudado de ideias",
    "subAccountDeletedInMinute": "Esta subconta será eliminada no próximo minuto",
    "changedMind": "Se utilizador've o Dinâmico a sua mente",
    "clickHere": "clicar aqui",
    "subAccountPaused": "Esta subconta está em pausa. Os seus clientes não conseguem iniciar sessão, mas a agência consegue. Para retomar esta conta",
    "subAccountRestricted": "Esta subconta está em pausa devido a aprovação pendente.",
    "subAccountVerificationPending": "Esta subconta está em pausa devido à verificação pendente de e-mail e telefone por parte do administrador da subconta.",
    "subAccountDeclined": "Esta subconta está em pausa devido a um pedido de aprovação recusado. Ainda pode retomar esta subconta a partir de ",
    "here": "aqui.",
    "reviewAndResume": "para rever e retomar esta subconta.",
    "incomingCalls": "Chamadas recebidas",
    "outgoingCalls": "Chamadas efetuadas",
    "totalTalktime": "Tempo Total de conversa",
    "incomingEmails": "Recebidas Gmail",
    "outgoingEmails": "Gmailde saída",
    "incomingSms": "Mensagens Corpo recebidas",
    "outgoingSms": "Mensagens de saída do Corpo",
    "contactsCreated": "Total de contactos criados",
    "appointmentsBooked": "Total de compromissos agendados",
    "totalFormSubmissions": "Total submissões de Formulário",
    "totalSurveySubmissions": "Total de envios de Inquérito",
    "totalFacebookFormSubmissions": "Total de submissões do Formulário do Facebook",
    "incomingGMBMessages": "Mensagens GBP recebidas",
    "outgoingGMBMessages": "Mensagens GBP enviadas",
    "gmbMessages": "Mensagens GBP",
    "fbMessages": "Mensagens do Facebook",
    "incomingFbMessages": "Mensagens recebidas do Facebook",
    "outgoingFbMessages": "Mensagens de saída do Facebook",
    "igMessages": "Mensagens do Instagram",
    "incomingIgMessages": "Mensagens recebidas do Instagram",
    "outgoingIgMessages": "Mensagens de saída do Instagram",
    "totalReviews": "Total de revisões",
    "positiveReviews": "Avaliações Positivas",
    "negativeReviews": "Avaliações Negativas",
    "back": "Voltar",
    "selectDashboards": "Selecionar painéis de controlo",
    "next": "Seguinte",
    "backToSubAccounts": "Voltar para subcontas",
    "pauseSchedule": "Pausa agenda",
    "resumeSchedule": "Retomar agenda",
    "editSchedule": "Editar agenda",
    "addSchedule": "Adicionar agenda",
    "selectReportToAdd": "Selecionar relatórios para Incluir in E-mail",
    "selectAll": "selecionar todos",
    "pauseScheduleConfirm": "O utilizador tem a certeza de que o utilizador pretende Pausar a agenda do relatório?",
    "resumeScheduleConfirm": "O utilizador tem a certeza de que o utilizador pretende Retomar a agenda do relatório?",
    "tasks": "Tarefas",
    "conversations": "Conversas",
    "users": "Utilizador",
    "dealOverview": "Visão geral do Negócio",
    "confirmAction": "Confirmar ação",
    "yes": "Sim",
    "no": "Não",
    "reportDetails": "Detalhes do relatório",
    "reportCreatedOn": "Relatório Criado Ativado",
    "searchByEmail": "Pesquisar por e-mail",
    "lastActivity": "Última atividade",
    "noRecords": "Não foram encontrados registos",
    "scheduleReport": "Agendar relatório",
    "schedule": "agenda",
    "save": "Guardar",
    "emailSubject": "Linha de assunto",
    "frequency": "Frequência",
    "daily": "diário",
    "weekly": "Semanal",
    "monthly": "Mensal",
    "nextScheduleDate": "Seguinte agenda Dados",
    "startingOn": "Iniciar o Ativado",
    "timeOfDay": "Data de Dia",
    "reportsToTimezone": "O relatório será enviado no fuso horário da subconta",
    "selectRecipients": "Selecionar destinatários",
    "invalidEmail": "Introduza um endereço de e-mail válido.",
    "testEmail": "E-mail de Testar",
    "selectTestRecipients": "Selecionar destinatários do Testar",
    "setupSubject": "Configure o Assunto acima para Testar o relatório",
    "sendTest": "Carregar Testar",
    "scheduleSimilarSchedules": "Agende um relatório semelhante para outras subcontas",
    "accountSummary": "Resumo da conta",
    "scheduleList": "Lista de agendamento",
    "subAccountName": "Nome da subconta",
    "nextRunDate": "Próxima data de execução",
    "reportSectionsAdded": "Segmentos do relatório adicionados",
    "status": "Estado",
    "scheduleAction": "Agendar ação",
    "cancel": "Cancelar",
    "pleaseWait": "A carregar…",
    "confirm": "Confirmar",
    "booked": "Marcado(a)",
    "confirmed": "Confirmado(a)",
    "showed": "Mostrado",
    "noShow": "Não comparência",
    "cancelled": "Cancelado",
    "unread": "Não lido",
    "engagement": "Compromisso",
    "reaction": "Reação",
    "deliverySummary": "Resumo da entrega",
    "successfulDelivery": "Entrega bem-sucedida",
    "opened": "Aberto",
    "clicked": "Clicado",
    "replied": "Respondidas",
    "unsubscribed": "Com subscrição anulada",
    "complained": "reclamou",
    "failed": "Falhado",
    "bounced": "Devolveu",
    "open": "Abrir",
    "won": "Ganhas",
    "abandoned": "Abandonado(a)",
    "lost": "Perdido(a)",
    "sent": "Enviado",
    "eject": "Ejetar",
    "delivered": "Enviado",
    "faceBookLeadForm": "Formulário de oportunidade potencial do Facebook",
    "overdue": "Vencido",
    "reviewsReceived": "Avaliações recebidas",
    "formBuilders": "Criadores de formulários",
    "switchToSaaS": "Mudar para SaaS",
    "numberOfContacts": "Total de contactos",
    "numberOfAppointments": "Total de compromissos",
    "outreach": "Alcance",
    "notSubAccountUser": "Não é um utilizador de subconta",
    "searchSubAccName": "Pesquisar por nome da subconta",
    "recipients": "Destinatários",
    "scheduleCreated": "Agenda de relatório de e-mail criada para ",
    "scheduleUpdated": "Agenda de relatório de e-mail atualizada para ",
    "scheduleNotCreated": "Não foi possível criar a agenda do relatório de e-mail para",
    "scheduleNotUpdated": "Não foi possível atualizar a agenda do relatório de e-mail para",
    "total": "Total",
    "inbound": "Recebidas",
    "outbound": "de saída",
    "totalEmails": "Total de e-mails",
    "inboundEmails": "E-mails recebidos",
    "outboundEmails": "E-mails enviados",
    "totalTextMessages": "Total de mensagens de texto",
    "inboundTextMessages": "Mensagens de texto recebidas",
    "outboundTextMessages": "Mensagens de texto de saída",
    "totalCalls": "Soma de Chamadas",
    "inboundCalls": "Chamadas recebidas",
    "outboundCalls": "Chamadas enviadas",
    "faceBookLeadFormSubmissions": "Submissões de formulário de oportunidade potencial do Facebook",
    "inboundGMBMessages": "Mensagens GBP recebidas",
    "outboundGMBMessages": "Mensagens GBP enviadas",
    "totalIgMessages": "Total de mensagens do Instagram",
    "inboundIgMessages": "Mensagens do Instagram recebidas",
    "outboundIgMessages": "Mensagens do Instagram enviadas",
    "totalfbMessages": "Total de mensagens do Facebook",
    "inboundfbMessages": "Mensagens do Facebook recebidas",
    "outboundfbMessages": "Mensagens do Facebook enviadas",
    "sitesCreatedFunnels": "Sites criados - funis",
    "sitesCreatedActiveFunnels": "Sites criados - funis ativos",
    "sitesCreatedWebsites": "Sites criados - sites",
    "sitesCreatedActiveWebsites": "Sites criados - sites ativos",
    "sitesCreatedForms": "Sites criados - formulários",
    "sitesCreatedActiveForms": "Sites criados - formulários ativos",
    "sitesCreatedSurveys": "Sites criados - inquéritos",
    "sitesCreatedActiveSurveys": "Sites criados - inquéritos ativos",
    "googleReviews": "Avaliações Google",
    "facebookReviews": "Revisões do Facebook",
    "inboundCallDuration": "Duração das chamadas recebidas (horas)",
    "outboundCallDuration": "Duração das chamadas enviadas (horas)",
    "pleaseSelect": "Selecionar",
    "subAccountIsDeleted": "Esta subconta foi eliminada",
    "subAccountIsPaused": "Esta subconta foi colocada em pausa",
    "success": "Sucesso",
    "error": "Erro",
    "testEmailSent": "E-mail de Testar enviado",
    "testEmailNotSent": "Não foi possível enviar o e-mail do Testar",
    "reviewRequest": "Pedidos de revisão",
    "pendingTransferDescription": "Outras agências solicitaram a transferência de subcontas para si.",
    "pendingTransferHeading": "Tem pedidos de transferência de subconta pendentes.",
    "subAccountTransfer": "Transferências de subcontas",
    "manageSubAccTransfer": "Gerir os seus pedidos de transferência de subconta",
    "subAccRequest": "Pedidos de subconta {tabName}",
    "receive": "Herdar",
    "send": "Enviar",
    "release": "Versão",
    "requests": "{count} pedidos",
    "subAccLimit": "O limite de utilização de subcontas foi atingido.",
    "subAccPlanLimit": "Utilizou 3/3 subcontas permitidas no seu plano atual.",
    "upgradeTime": "Está na hora de fazer um upgrade!",
    "upgradeHigher": "Faça upgrade para um plano superior para aceitar a transferência da subconta.",
    "browse": "Explorar planos",
    "pendingTransferTitle": "Já existe um pedido de transferência pendente para esta subconta.",
    "unableTransfer": "Não é possível transferir a subconta para esta agência.",
    "unableEjectCancel": "Não é possível cancelar o pedido de ejeção da subconta.",
    "EjectErrorDetails": "O pedido de ejeção da subconta não pode ser cancelado.",
    "hippaErrorDescription": "Esta subconta está ativada para HIPAA e não pode ser transferida para uma agência não-HIPAA.",
    "pendingTransferErrorDescription": "Cancele o pedido de transferência existente para esta subconta antes de criar um novo.",
    "receivingAgency": "Agência recetora",
    "releasingAgency": "Agência de lançamento",
    "noOfContacts": "Total de contactos",
    "requestedDate": "Data de pedido",
    "action": "Ação",
    "cancelTransfer": "Cancelar transferência",
    "decline": "Rejeitar",
    "cancelTransferRequest": "Cancelar pedido de transferência de subconta?",
    "cancelEjectRequest": "Cancelar pedido de ejeção de subconta?",
    "cancelRequestDescription": "A agência recetora deixará de ver este pedido de transferência e a subconta {name} não será transferida.",
    "cancelEjectRequestDescription": "O utilizador selecionado já não poderá criar uma nova agência a partir da subconta {name}.",
    "declineRequest": "Recusar pedido de transferência de subconta?",
    "declineRequestDescription": "O pedido será recusado e a subconta {name} não será transferida para a sua agência.",
    "approveTransfer": "Aprovar a transferência da subconta para a sua agência?",
    "approveTransferDescription": "A subconta {name} será transferida para a sua agência.",
    "transferNow": "Transferir agora",
    "cancelNow": "Cancelar agora",
    "transferErrorDetails": "Esta subconta não pode ser transferida.",
    "cancelRequest": "Cancelar pedido",
    "received": "Recebido",
    "approve": "Aprovar",
    "goBack": "Voltar atrás",
    "done": "Concluído",
    "subAccountTransferred": "A subconta foi transferida com sucesso!",
    "subAccountTransferDescription": "Embora a subconta tenha sido transferida, alguns ativos, como utilizadores, números de telefone, contas Mailgun e listagens Yext, podem demorar 10 a 15 minutos a aparecer no destino.",
    "activeSubscriptionsAlert": "A Localização tem Dinâmico Assinatura. Cancele todas as Assinatura Antes de Transferência cega a Localização. Lista de Dinâmico Assinatura: {subscriptions}",
    "isSaasEnabled": "Ativado por SaaS",
    "typeToSearch": "Escreva para pesquisar",
    "dateAdded": "Data adicionada",
    "emailEngagement": "Interação por e-mail",
    "emailReaction": "Reação de e-mail",
    "emailDeliverySummary": "Resumo da entrega por e-mail",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Resumo da conta – {subAccountName}",
    "test": "Testar",
    "scheduleExists": "A agenda existe",
    "aToZ": "A - Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Apenas os utilizadores administradores podem adicionar novas subcontas.",
    "locationName": "Nome da localização",
    "transferCompleted": "O pedido de transferência para esta localização já foi processado. Atualize a página.",
    "unauthorizedTransfer": "o utilizador não está autorizado a executar esta Ação. Apenas proprietários de Agências podem executar esta Ação.",
    "bulkLocationTransfer": "Transferência em massa de subcontas",
    "singleRequest": "Pedido único",
    "bulkRequest": "Pedido em massa",
    "backToLocationTransfer": "Voltar à transferência de localização",
    "initiateBulkTransfer": "Inicie a transferência em massa de subcontas",
    "initiateBulkTransferDescription": "Selecione as subcontas que pretende transferir ou introduza os seus IDs separados por vírgulas.",
    "subAccountId": "ID da subconta",
    "selectFromList": "Selecione na lista",
    "addManually": "Adicionar manualmente",
    "accountsSelected": "{count} selecionado(s)",
    "selectAllSubAccounts": "selecionar todos",
    "removeAll": "Extraia tudo",
    "addManualLocations": "Adicione os IDs de localização separados por vírgula",
    "manualAllLocationIds": "IDs de Localização do utilizador subcontata que deseja Transferir, Separado Via vírgulas.",
    "enterLocationIds": "Introduza os IDs de localização",
    "selectSubAccounts": "Selecione as subcontas e transfira para uma agência existente",
    "subAccountTransferWarning": "todos os ativos da subconta e o Utilizador obterão o Descarregar.",
    "proceed": "Prosseguir",
    "bulkRequestSubmitted": "Pedido de transferência em massa enviado",
    "bulkRequestSubmittedDescription": "Cada subconta será transferida assim que a agência recetora aceitar o pedido de transferência. Pode acompanhar o estado do pedido na página ❝{pagename}❞. (desde que sejam elegíveis)",
    "bulkTransferRequestFailed": "O pedido de transferência em massa falhou",
    "errorLocations": "Subcontas com erro",
    "viewDetails": "Ver detalhes",
    "somethingWrong": "Algo correu mal. Tente novamente.",
    "confirmBulkRequest": "Confirmar pedido de transferência em massa?",
    "bulkTransferAccounts": "Transferir em massa as \"{count}\" subcontas selecionadas?",
    "confirmDetails": "Confirme os detalhes antes de transferir.",
    "transferConsent": "Tenho o Ler e comentei o guia acima e o Consentimento a todas as limitações.",
    "transferInfo": "A transferência de subcontas está sujeita à aceitação pela agência recetora da sua conta.",
    "receivingRelNo": "Número de relação da agência recetora",
    "enterRelNo": "Introduza o número da relação",
    "transferConfirmation": "Ao concluir esta ação, os pedidos de transferência em massa serão enviados para a agência recebida ({ relNo }). todos sub-conta o utilizador've selecionado será descarregado assim que a agência recebida o aceitar. Tenha em atenção que esta ação é irreversível para todas as subcontas incluídas in Transferir.",
    "confirmPassword": "Confirme Via ao escrever password abaixo",
    "enterPassword": "Introduzir palavra-passe",
    "requestTransfer": "Pedir transferência",
    "confirmTransfer": "Confirmar transferência",
    "notNow": "Não agora",
    "invalidRelNo": "Número da relação inválido",
    "invalidPassword": "password inválida .",
    "searchSubAccounts": "Pesquisar subcontas",
    "searchSubAccountsId": "Pesquisar ID da subconta",
    "takeAction": "Tomar medidas",
    "sub_account_details": "Detalhes da subconta",
    "no_of_contacts": "Total de contactos",
    "transfer_status": "Estado da transferência",
    "error_info": "Informações de erro",
    "bulk_transfer_status": "Estado da transferência em massa de subcontas",
    "pending": "Pendente",
    "processed": "Processado",
    "reject_all": "Rejeitar tudo",
    "accept_all": "Aceitar tudo",
    "cancel_all": "Cancelar tudo",
    "clearAll": "Limpar tudo",
    "refresh": "Atualizar",
    "rejected": "Negado",
    "decline_transfer": "Recusar transferência",
    "decline_bulk_transfer": "Recusar pedido de transferência de subcontas em massa?",
    "decline_bulk_transfer_description": "O pedido será recusado e as subcontas {length} não serão transferidas para a sua agência.",
    "accept_bulk_transfer": "Aceitar pedido de transferência em massa de subcontas?",
    "accept_bulk_transfer_description": "O pedido será aceite e as subcontas {length} serão transferidas para a agência.",
    "cancel_bulk_transfer": "Cancelar transferência em massa?",
    "cancel_bulk_transfer_description": "Tem a certeza de que pretende cancelar esta transferência em massa de subcontas {length} para \"{name}\"?",
    "consent_sub_account_transfer": "Por favor, Leia e Consentimento para {link}",
    "sub_account_transfer_guidelines": "Diretrizes sobre transferências de subcontas",
    "valid_rel": "Introduza um número de relação válido",
    "something_went_wrong": "Algo correu mal. Tente novamente.",
    "export": "Exportar",
    "export_success": "Os dados que o utilizador solicitaram estão a ser processados. o utilizador irá Herdar um e-mail com os dados in alguns Dados.",
    "export_failed": "Não foi possível processar os dados do utilizador pedidos. Por favor, tentar novamente mais tarde.",
    "selectAllError": "Só pode selecionar 1000 subcontas de cada vez.",
    "max1000": "(Máximo 1000)",
    "subAccountCount": "Contagem de subcontas",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "O utilizador tem a certeza de que o utilizador pretende Pausa {count} relatórios?",
    "scheduleBulkResumeConfirm": "O utilizador tem a certeza de que o utilizador pretende Retomar {count} relatórios?",
    "resume": "Retomar",
    "pause": "Pausa",
    "resumeSelected": "Retomar Selecionado",
    "pauseSelected": "Pausa selecionada",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} relatórios selecionados",
    "selectAllXReports": "Selecione os {count} relatórios",
    "scheduleStatus": "Estado do agendamento",
    "scheduleSearchPlaceholder": "Pesquisar por e-mail ou nome da localização",
    "subAccountsPerPage": "Subcontas por página",
    "previous": "Anterior",
    "scheduleBulkAction": "Agendar ação em massa",
    "all": "Todos",
    "active": "Ativo",
    "paused": "Em pausa",
    "scheduleUpdatedSuccessfully": "agenda atualizada com sucesso",
    "saveChanges": "Guardar alterações",
    "pauseSchedulesTitle": "Pausar relatórios Ativo Agendado",
    "pauseSchedulesDescription": "clicar para Pausa agora relatórios Ativo.",
    "pauseSchedulesAlert": "Isto só afetará as contas que são agora Dinâmico.",
    "pauseAllSchedulesBtnText": "Colocar todos os relatórios agendados em pausa",
    "autoScheduleTitle": "Agendamento automático para novas contas",
    "autoScheduleLabel": "Crie automaticamente relatórios programados quando uma nova subconta for adicionada.",
    "autoScheduleAlert": "Desativar este utilizador Se deseja configurar manualmente para a nova Conta.",
    "autoScheduleEnabledForNewAccounts": "Agendamento automático Ativado para novo Conta",
    "autoScheduleDisabledForNewAccounts": "Agendamento automático Desativado para nova Conta",
    "deleted": "Eliminado",
    "locationPaused": "Localização em pausa",
    "scheduleSettingsModalTitle": "Definições do relatório de agenda",
    "selectAllSchedules": "selecionar todos a agenda",
    "selectScheduleForLocation": "Selecionar um agenda para {location}",
    "openSettings": "Abrir definições",
    "resumeScheduleForLocation": "Retomar agenda para {location}",
    "pauseScheduleForLocation": "Pausa agenda para {location}",
    "actions": "Ações",
    "deselectAll": "Desmarcar todos",
    "scheduleBulkActionResumeSuccess": "em massa ativação in curso — colocar em espera, suspender Desativado Ativado novas atividades",
    "scheduleBulkActionPauseSuccess": "Colocar relatórios em pausa — aguarde antes de realizar mais ações",
    "bulkActionCreationError": "Outra ação em massa está em curso. Tente novamente dentro de instantes.",
    "bulkActionInProgress": "em massa Ação já in curso",
    "scheduledReports": "Relatórios Agendado",
    "scheduleBulkActionCompleted": "em massa Ação concluída com sucesso",
    "pauseAllSchedulesModalTitle": "Pretende colocar os relatórios em pausa?",
    "pauseAllSchedulesModalText": "Isto colocará em pausa todos os relatórios agendados ativos em subcontas.",
    "addLocationIdsPlaceholder": "Adicione IDs de localização que pretende transferir...",
    "helloWorld": {
      "count": "A contagem é {count}",
      "editIntro": "Editar",
      "editAction": "Para testar HMR",
      "checkOut": "Marca de verificação",
      "officialStarter": ", a versão inicial oficial do Vue + Vite",
      "install": "Instalar",
      "installDescription": "No seu IDE para uma melhor experiência de programador",
      "learnMore": "Clique nos logótipos do Vite e do Vue para saber mais"
    },
    "home": {
      "testMessage": "Olá! Esta é a página inicial de Testar!"
    },
    "reports": {
      "incoming": "Recebidas",
      "outgoing": "Feitas",
      "duration": "Duração",
      "contactsCount": "Total de contactos",
      "appointmentsCount": "Total de compromissos",
      "formSubmissions": "Envios de formulários",
      "surveySubmissions": "Envios de inquéritos",
      "facebookFormSubmissions": "Envios de formulários do Facebook",
      "funnels": "Funis",
      "websites": "Sítios Web",
      "forms": "Formulários",
      "surveys": "Inquéritos",
      "gbpMessages": "Mensagens GBP",
      "facebookMessages": "Mensagens do Facebook",
      "instagramMessages": "Mensagens do Instagram",
      "reviews": "Críticas",
      "positives": "Positivos",
      "negatives": "Negativos"
    },
    "timeOptions": {
      "00": "00h00",
      "01": "01h00",
      "02": "02h00",
      "03": "03h00",
      "04": "04h00",
      "05": "05h00",
      "06": "06h00",
      "07": "08h00",
      "08": "07h00",
      "09": "09h00",
      "10": "10h00",
      "11": "11h00",
      "12": "12h00",
      "13": "13h00",
      "14": "14h00",
      "15": "15h00",
      "16": "16h00",
      "17": "17h00",
      "18": "18h00",
      "19": "19h00",
      "20": "20h00",
      "21": "21h00",
      "22": "22h00",
      "23": "23h00"
    },
    "transferStatus": {
      "pending": "Pendente",
      "processed": "Processado",
      "canceled": "Cancelado",
      "cancelled": "Cancelado",
      "completed": "Concluído",
      "rejected": "Recusado",
      "failed": "Falhado",
      "payment_pending": "Pagamento pendente"
    }
    }
